import { Component, OnInit, Input, Host, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { SummaryFlowViewComponent } from "../summary-flow-view/summary-flow-view.component";
import { SummaryConfig, QuestionKind } from '../../../../common/models/flow.dto';
import { RuleCompiler } from "../../../../flow/services/rule-compiler.service";
import { deepClone } from '../../../../builder/models/editor.model';
import { Domain } from '../../../../builder/models/domain.model';

@Component({
    selector: 'summary-item',
    templateUrl: './summary-item.component.html',
    styleUrls: ['./summary-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SummaryItemComponent implements OnInit {
    @Input() isPreview: boolean;
    @Input() noteIcon: string;
    @Input() question: SummaryConfig;

    questionKind = QuestionKind;

    showNotes: boolean = false;    

    private _showInitialValue: boolean = false;

    get originalValue(): any {
        let result: any = "";
        if (this.question.initialValueRule) {    
            let rule = this.compiler.compileSyncRule<any>(this.question.initialValueRule, this.summaryComponent.componentContext, "");
            result = rule();      

            result = this.formatValueForDisplay(result);
        }
        return result;
    }

    get hasInitialValue(): boolean {
        let result = false;
        if (this.question.initialValueRule && this.originalValue) {
            result = true
        }
        return result;
    }



    get showInitialValue(): boolean {
        return this.hasInitialValue && this._showInitialValue;
    }

    get value(): any {
        return this.summaryComponent.getQuestionValue(this.question, this.question.contextValue);
    }

    get valueHasChanged(): boolean {
        let result = false;
        let convertedValue = "";
        if (this.hasInitialValue) {
            const originalExists = this.originalValue !== undefined && this.originalValue !== null && typeof(this.originalValue) !== 'object';
            const valueExists = this.value !== undefined && this.value !== null && (typeof(this.value) !== 'object' || this.question.type === QuestionKind.ListEntry);
            if (originalExists && valueExists) {
                let numberVal = Number(this.originalValue.toString().replace(/,/gi, '').replace('$', ''));
                if (!isNaN(numberVal)) {
                    let valueFloat = parseFloat(this.value.toString().replace(/,/gi, '').replace('$', ''));
                    result = !isNaN(valueFloat) && valueFloat !== numberVal;
                } else {
                    convertedValue = this.formatValueForDisplay(this.value);
                    result = this.originalValue.toString().toLocaleUpperCase() != convertedValue.toString().toLocaleUpperCase();
                }              
            }
        }            
        return result;
    }
    
    constructor(
        @Host() public summaryComponent: SummaryFlowViewComponent,        
        private detector: ChangeDetectorRef,
        private compiler: RuleCompiler
    ) {}
     
    ngOnInit() {
        this.showNotes = this.summaryComponent.canShowNote(this.question);        
    }

    addNote(event: MouseEvent, contextTarget: string): void {
        if (this.isPreview)
            return;

        event.preventDefault();
        this.summaryComponent.flowComponent.addQuestionNote(contextTarget).subscribe((result) => {
            if (result)
                this.noteIcon = this.summaryComponent.getNoteIcon(this.question.contextValue);
        });
    }

    formatValueForDisplay(result) {
        let convertedItem = deepClone(result);
        if (this.question.type === QuestionKind.DatePicker && typeof (this.value) == 'object') {
            convertedItem = this.summaryComponent.dateService.convertUtcStringToMMDDYYYY(result);
        }

        let domain: Domain[] = null;
        //Fetch the relevant domain value for the initial value, if applicable
        if (this.question.questionDomain !== null && this.question.questionDomain !== undefined
            && this.question.questionDomain !== '') {
            domain = this.summaryComponent.domains.get(this.question.questionDomain);

            if (domain && domain.length > 0 && typeof (result) == "string") {
                convertedItem = this.pullMatchingDomainDefinition(domain, result);
            }
        }

        if (this.question.type === QuestionKind.MultiselectCheckbox) {
            convertedItem = result.toString();

            if (domain && typeof (result) == "object") {
                let convertedSelectedItems: string[] = [];
                for (let x = 0; x < result.length; x++) {
                    let selectedItem = result[x];
                    //If a domain was selected try to pair this entry with its definition
                    if (domain) {
                        convertedSelectedItems.push(this.pullMatchingDomainDefinition(domain, selectedItem));
                    }
                }
                convertedItem = convertedSelectedItems.toString();
            }
        } else if (this.question.type === QuestionKind.ListEntry) {
            convertedItem = result.join(', ');
        }


        return convertedItem;
    }

    pullMatchingDomainDefinition(domain: Domain[], code: string): string {
        let convertedItem = "";
        let matchingResult = domain.filter(a => a.Code.toLocaleUpperCase() === code.toLocaleUpperCase());
        if (matchingResult !== null && matchingResult !== undefined && matchingResult.length > 0)
            convertedItem = matchingResult[0].Definition;

        return convertedItem;
    }

    toggleShowInitialValue(value: boolean): void {
        this._showInitialValue = value;
        this.detector.detectChanges();
    }
}
